const BRAND = "#90c740";

const emailShell = (title, bodyHtml) => `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; background-color: #f4f4f4; margin: 0; padding: 0; }
  .email-container { max-width: 600px; margin: 20px auto; background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }
  .header { background-color: ${BRAND}; padding: 24px; text-align: center; }
  .header h1 { margin: 0; color: white; font-size: 22px; font-weight: 600; }
  .content { padding: 32px; color: #333; line-height: 1.6; }
  .content h2 { margin-top: 0; color: #2c3e50; font-size: 18px; }
  .details-box { background: #f8fafc; padding: 20px; border-left: 4px solid ${BRAND}; margin: 24px 0; border-radius: 4px; }
  .details-item { margin-bottom: 8px; }
  .details-label { font-weight: bold; color: #555; min-width: 110px; display: inline-block; }
  .button-container { text-align: center; margin-top: 28px; }
  .button { display: inline-block; background-color: ${BRAND}; color: white !important; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: bold; font-size: 15px; }
  .footer { background-color: #f1f1f1; padding: 20px; text-align: center; font-size: 12px; color: #888; border-top: 1px solid #e1e1e1; }
</style>
</head>
<body>
  <div class="email-container">
    <div class="header"><h1>${title}</h1></div>
    <div class="content">${bodyHtml}</div>
    <div class="footer">
      <p>&copy; ${new Date().getFullYear()} ATraq. All rights reserved.</p>
      <p>This is an automated message, please do not reply.</p>
    </div>
  </div>
</body>
</html>`;

const taskDetailsBlock = ({ title, priority, status, dueDate, category, assigneeName, actorName }) => `
  <div class="details-box">
    <div class="details-item"><span class="details-label">Task:</span> ${title}</div>
    ${category ? `<div class="details-item"><span class="details-label">Category:</span> ${category}</div>` : ""}
    ${priority ? `<div class="details-item"><span class="details-label">Priority:</span> ${priority}</div>` : ""}
    ${status ? `<div class="details-item"><span class="details-label">Status:</span> ${status}</div>` : ""}
    ${dueDate ? `<div class="details-item"><span class="details-label">Due date:</span> ${dueDate}</div>` : ""}
    ${assigneeName ? `<div class="details-item"><span class="details-label">Assignees:</span> ${assigneeName}</div>` : ""}
    ${actorName ? `<div class="details-item"><span class="details-label">Updated by:</span> ${actorName}</div>` : ""}
  </div>`;

export const getTaskAssignedEmail = ({ recipientName, taskTitle, priority, status, dueDate, category, assigneeName, actorName, taskLink }) =>
  emailShell(
    "New Task Assignment",
    `
      <h2>Hello ${recipientName},</h2>
      <p>You have been assigned a task on the ATraq internal task board.</p>
      ${taskDetailsBlock({ title: taskTitle, priority, status, dueDate, category, assigneeName, actorName })}
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );

export const getTaskCreatedEmail = ({ recipientName, taskTitle, priority, status, dueDate, category, assigneeName, creatorName, taskLink }) =>
  emailShell(
    "New Task Created",
    `
      <h2>Hello ${recipientName},</h2>
      <p>${creatorName} created a new task and assigned it to you.</p>
      ${taskDetailsBlock({ title: taskTitle, priority, status, dueDate, category, assigneeName, actorName: creatorName })}
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );

export const getTaskStatusChangedEmail = ({
  recipientName,
  taskTitle,
  oldStatus,
  newStatus,
  priority,
  category,
  actorName,
  taskLink,
}) =>
  emailShell(
    "Task Status Updated",
    `
      <h2>Hello ${recipientName},</h2>
      <p>The status of a task you created has been updated.</p>
      ${taskDetailsBlock({ title: taskTitle, priority, category, status: `${oldStatus} → ${newStatus}`, actorName })}
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );

export const getTaskCommentEmail = ({ recipientName, taskTitle, category, commentAuthor, commentPreview, taskLink }) =>
  emailShell(
    "New Task Comment",
    `
      <h2>Hello ${recipientName},</h2>
      <p><strong>${commentAuthor}</strong> posted a comment on task <strong>${taskTitle}</strong>.</p>
      ${category ? `<p><strong>Category:</strong> ${category}</p>` : ""}
      <div class="details-box">
        <div class="details-item"><span class="details-label">Comment:</span></div>
        <p style="margin:8px 0 0;">${commentPreview}</p>
      </div>
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );

export const getTaskReopenedEmail = ({ recipientName, taskTitle, status, category, actorName, taskLink }) =>
  emailShell(
    "Task Reopened",
    `
      <h2>Hello ${recipientName},</h2>
      <p>A task assigned to you has been reopened and needs attention.</p>
      ${taskDetailsBlock({ title: taskTitle, status, category, actorName })}
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );

export const getTaskArchivedEmail = ({ recipientName, taskTitle, category, actorName, taskLink }) =>
  emailShell(
    "Task Archived",
    `
      <h2>Hello ${recipientName},</h2>
      <p>A task you are involved with has been archived.</p>
      ${taskDetailsBlock({ title: taskTitle, category, actorName })}
      <div class="button-container"><a href="${taskLink}" class="button">View Task</a></div>
    `
  );
